module.exports = __webpack_public_path__ + "img/app.ae70fb3a.png";